import { useProvideCoreFetch } from '~/composables/useProvideCoreFetch'

export default defineNuxtPlugin(async () => {
  if (import.meta.env.TEST) return

  const { coreFetch } = useProvideCoreFetch()
  await callOnce('warudo', () => coreFetch.$get('/za/warudo/'))
})
